module.exports = "\n.d3-chart {\n    width: 100%;\n    height: 300px;\n}\n.d3-chart .axis text{\n    font: 14px sans-serif;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/chart/production/production.component.css
// module id = ./src/app/chart/production/production.component.css
// module chunks = main